import { render, staticRenderFns } from "./rejected-orders-table.vue?vue&type=template&id=52efc98e&scoped=true"
import script from "./rejected-orders-table.vue?vue&type=script&lang=js"
export * from "./rejected-orders-table.vue?vue&type=script&lang=js"
import style0 from "./rejected-orders-table.vue?vue&type=style&index=0&id=52efc98e&prod&lang=scss"
import style1 from "./rejected-orders-table.vue?vue&type=style&index=1&id=52efc98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efc98e",
  null
  
)

export default component.exports